// Helper puri e costanti condivise dal flusso "Prepara" (PreparaDialog).

export const DURATE_OPZIONI = [1, 2, 3, 5, 7, 10, 14, 15, 20, 30];

const storageFactor = (u) => {
  const unit = (u || "g").toLowerCase().trim();
  if (["kg", "litri", "litro", "l", "lt"].includes(unit)) return 1000;
  if (unit === "hg") return 100;
  if (unit === "cl") return 10;
  return 1;
};

// Converte una quantità nell'unità piccola (g/ml/pz) per lo storage/food cost.
export const toSmall = (q, u) => {
  const n = parseFloat(q) || 0;
  return Number((n * storageFactor(u)).toFixed(6));
};

// Nel form e nel riepilogo mostra l'UDM scelta senza cambiare il dato salvato.
export const fromSmall = (q, u) => {
  const n = parseFloat(q) || 0;
  return Number((n / storageFactor(u)).toFixed(6));
};

export const formatSmallQuantity = (q, u) => {
  const unit = (u || "g").toLowerCase().trim();
  const label = ["litri", "litro", "l", "lt"].includes(unit) ? "L" : unit;
  return `${fromSmall(q, unit)} ${label}`;
};

export const updateQuantityInput = (ingredient, value) => ({
  ...ingredient,
  quantita_input: value,
  quantita_grammi: value === "" ? "" : toSmall(value.replace(",", "."), ingredient.unita_misura),
});

// Un ingrediente è completo se ha la foto OPPURE lotto + scadenza + quantità.
export const isIngredienteCompleto = (ing) => {
  if (ing.foto_path) return true;
  if (ing.lotto_origine_id) {
    return ing.lotto_origine_quantita_base >= (parseFloat(ing.quantita_grammi) || 0);
  }
  return ing.lotto_numero?.trim() && ing.data_scadenza?.trim() && ing.quantita_grammi > 0;
};

const normalizeUdm = (unita) => {
  const raw = (unita || "g").toLowerCase().trim();
  const aliases = { litro: "lt", litri: "lt", l: "lt", pezzo: "pz", pezzi: "pz", fetta: "pz", bustina: "pz" };
  return aliases[raw] || raw;
};

export const famigliaUdm = (unita) => {
  const u = normalizeUdm(unita);
  if (["kg", "hg", "g"].includes(u)) return "peso";
  if (["lt", "cl", "ml"].includes(u)) return "volume";
  if (u === "pz") return "pezzi";
  return u;
};

// Identità del lotto, non il nome richiesto dalla ricetta. Per i lotti storici
// privi di nome usa solo l'anagrafica dell'ingrediente del medesimo locale.
export const nomeProdottoDelLotto = (lotto, ingredienti = [], localeId) => {
  if (!lotto || (localeId && lotto.locale_id && lotto.locale_id !== localeId)) return "";
  const nomeSalvato = (lotto.is_composto && lotto.nome_preparazione)
    || lotto.nome_prodotto || lotto.ingrediente_nome;
  if (typeof nomeSalvato === "string" && nomeSalvato.trim()) return nomeSalvato.trim();
  const ingrediente = ingredienti.find(item => item.id === lotto.ingrediente_id
    && (!localeId || !item.locale_id || item.locale_id === localeId));
  return typeof ingrediente?.nome === "string" ? ingrediente.nome.trim() : "";
};

export const leggiQuantitaLotto = (lotto) => {
  const rawQuantita = lotto?.quantita_preparata;
  let valore = rawQuantita !== null && rawQuantita !== undefined && rawQuantita !== "" ? Number(rawQuantita) : NaN;
  let unita = lotto?.unita_misura;
  if (!Number.isFinite(valore) || !unita) {
    const match = String(lotto?.quantita_testo || "").toLowerCase().replace(",", ".")
      .match(/(-?\d+(?:\.\d+)?)\s*(kg|hg|g|litri|litro|lt|l|cl|ml|pz|pezzi|pezzo|fetta|bustina)\b/);
    if (!match) return null;
    valore = Number(match[1]);
    unita = match[2];
  }
  const normalized = normalizeUdm(unita);
  const factors = { kg: 1000, hg: 100, lt: 1000, cl: 10 };
  return {
    valore,
    unita: normalized,
    quantitaBase: valore * (factors[normalized] || 1),
    famiglia: famigliaUdm(normalized),
  };
};

export const lottiDisponibiliPerIngrediente = (lotti, ingrediente) => {
  const oggi = new Date().toISOString().slice(0, 10);
  const famiglia = famigliaUdm(ingrediente?.unita_misura || "g");
  return (lotti || []).map((lotto) => ({ lotto, quantita: leggiQuantitaLotto(lotto) }))
    .filter(({ lotto, quantita }) => {
      const scadenza = lotto.data_scadenza_aperto || lotto.data_scadenza;
      return lotto.ingrediente_id === ingrediente?.ingrediente_id
        && !lotto.is_archived
        && lotto.stato !== "consumato"
        && scadenza && scadenza >= oggi
        && quantita?.quantitaBase > 0
        && quantita.famiglia === famiglia;
    })
    .sort((a, b) => {
      const expA = a.lotto.data_scadenza_aperto || a.lotto.data_scadenza;
      const expB = b.lotto.data_scadenza_aperto || b.lotto.data_scadenza;
      return expA.localeCompare(expB);
    });
};
